import {
  MetricsCardVariantsEnum,
  MetricsCardVariantsProps,
} from './metrics-card.type'

import { tokens } from '@mercai/clever'

export const variants = (
  t: (val: string) => string,
): Record<keyof typeof MetricsCardVariantsEnum, MetricsCardVariantsProps> => ({
  rfq_attended: {
    backgroundColor: tokens.colors.primary1000,
    circleColor: tokens.colors.primary700,
    rotate: 0,
    title: t('rfq_attended'),
  },
  gmv_acquisition: {
    backgroundColor: tokens.colors.primary700,
    circleColor: tokens.colors.primary1000,
    rotate: 0,
    title: t('gmv_acquisition'),
  },
  gmv_paid: {
    backgroundColor: tokens.colors.secondary1000,
    circleColor: tokens.colors.secondary700,
    rotate: -10,
    title: t('gmv_paid'),
  },
  orders_delivered: {
    backgroundColor: tokens.colors.primary1000,
    circleColor: tokens.colors.primary700,
    rotate: -10,
    title: t('orders_delivered'),
  },
  active_clients: {
    circleColor: tokens.colors.secondary700,
    backgroundColor: tokens.colors.secondary1000,
    rotate: -17,
    title: t('active_clients'),
  },
})
